/**
 * 代办事项
 */
const todoRouter = {
  path: '/msg',
  component: () => import('@/views/layout'),
  redirect: '/message/todo/list',
  meta: {
    title: '申请审批',
    icon: require('@/assets/slider/daiban.png'),
    alwaysShow: true // 针对单个的
  },
  alwaysShow: true,
  children: [
    {
      path: 'todo/list', // 为了处理todo
      name: 'todoList',
      component: () => import('@/views/message_center'),
      meta: {
        title: '申请审批',
        icon: require('@/assets/slider/daiban.png'),
        nostyle: true,
        tips: true
      }
    }

  ]
}

export default todoRouter
